import BaseService from "./BaseService";

export default class MatriculaService extends BaseService {

  constructor(self) {
    super(self);
  }

  ObterMatricula(parameters) {
    return this.ExecutaFetch("/api/Matricula/ObterMatricula", "POST", parameters);
  }
}